/**
 * This file is auto-generated. Do not edit directly.
 * To update, run the generateIconImports.js script.
 */
import { IconName } from '../types';

/**
 * Array of all available icon names for use in dropdowns or selectors
 */
export const iconOptions: IconName[] = [
  'Icon3By3GridOutline',
  'Icon3DimensionsOutline',
  'Icon4LframeworkOutline',
  'IconAcceptOutline',
  'IconAccessibilityOutline',
  'IconAccessibleOutline',
  'IconAccountAlertOutline',
  'IconAccountBoxOutline',
  'IconAccountCheckOutline',
  'IconAccountConvertOutline',
  'IconAccountRemoveOutline',
  'IconAccountSwitchOutline',
  'IconAddUserOutline',
  'IconAggregateOutline',
  'IconAirFilterOutline',
  'IconAirplaneOutline',
  'IconAlertOutline',
  'IconAnalysisOutline',
  'IconApparelOutline',
  'IconArchiveAltOutline',
  'IconArchiveOutline',
  'IconArrowDecreaseOutline',
  'IconArrowDecreaseSmallOutline',
  'IconArrowDownBoldOutline',
  'IconArrowDownOutline',
  'IconArrowDownSmallOutline',
  'IconArrowIncreaseOutline',
  'IconArrowIncreaseSmallOutline',
  'IconArrowLeftOutline',
  'IconArrowLeftSmallOutline',
  'IconArrowRightOutline',
  'IconArrowRightSmallOutline',
  'IconArrowUpBoldOutline',
  'IconArrowUpOutline',
  'IconArrowUpSmallOutline',
  'IconArtThemesOutline',
  'IconAskQuestionOutline',
  'IconAtmOutline',
  'IconAudienceOutline',
  'IconAutomobileOutline',
  'IconAvatarOutline',
  'IconAwardRibbonOutline',
  'IconBarChartOutline',
  'IconBargraphOutline',
  'IconBatteryHighOutline',
  'IconBatteryLowOutline',
  'IconBatteryMediumOutline',
  'IconBeakerOutline',
  'IconBiometricsOutline',
  'IconBoatOutline',
  'IconBookOutline',
  'IconBotOutline',
  'IconBoxOpenOutline',
  'IconBoxOutline',
  'IconBridgeChartOutline',
  'IconBrightnessOutline',
  'IconBubblePlotOutline',
  'IconBudgetOutline',
  'IconBuildingOutline',
  'IconBusPublicTransportationOutline',
  'IconBusinessServicesPrinterOutline',
  'IconButtonOutline',
  'IconCalculatorOutline',
  'IconCalendarAcceptedOutline',
  'IconCalendarClockOutline',
  'IconCalendarDeclinedOutline',
  'IconCalendarOutline',
  'IconCallOutline',
  'IconCameraMicSpeakersOutline',
  'IconCameraOutline',
  'IconCapitalOutline',
  'IconCarersSpaceOutline',
  'IconCenterMapOutline',
  'IconChangeOutline',
  'IconCheckHookOutline',
  'IconCheckMarkOutline',
  'IconCheckboxOutline',
  'IconChevronDoubleDownOutline',
  'IconChevronDoubleLeftOutline',
  'IconChevronDoubleRightOutline',
  'IconCircleCheckmarkOutline',
  'IconCircleDeleteOutline',
  'IconCircleEmptyOutline',
  'IconCircleMinusOutline',
  'IconCircleMoreOutline',
  'IconCirclePercentOutline',
  'IconCirclePlusOutline',
  'IconCircleRadioOutline',
  'IconCircleSaveOutline',
  'IconCircleStarOutline',
  'IconCircleWarningOutline',
  'IconCircuitBoardBoxOutline',
  'IconClappingApplauseOutline',
  'IconClinicOutline',
  'IconCloseOutline',
  'IconCloudAlertOutline',
  'IconCloudCheckOutline',
  'IconCloudClockOutline',
  'IconCloudDeleteOutline',
  'IconCloudDisableOutline',
  'IconCloudLoadingOutline',
  'IconCloudOutline',
  'IconCogsOutline',
  'IconCollapseChevronOutline',
  'IconCommentOutline',
  'IconCommentaryOutline',
  'IconCommunityOutline',
  'IconCompassOutline',
  'IconConfettiCelebrationOutline',
  'IconConfigurationOutline',
  'IconConfirmedOutline',
  'IconContactsOutline',
  'IconContainerOutline',
  'IconConvertOutline',
  'IconCookieOutline',
  'IconCopyOutline',
  'IconCostDollarOutline',
  'IconCreditCardOutline',
  'IconCreditCardPaymentOutline',
  'IconCurrencyExchangeOutline',
  'IconDatabricksOutline',
  'IconDashboardOutline',
  'IconDagsterOutline',
  'IconDataAddprefixOutline',
  'IconDataAddsuffixOutline',
  'IconDataLettersOutline',
  'IconDataLowercaseOutline',
  'IconDataMixedOutline',
  'IconDataNumericOutline',
  'IconDataOutline',
  'IconDataTrimOutline',
  'IconDataUppercaseOutline',
  'IconDataValueOutline',
  'IconDatabaseOutline',
  'IconDatabaseSearchOutline',
  'IconDebtFreeOutline',
  'IconDeleteOutline',
  'IconDeskChairOutline',
  'IconDesktopOutline',
  'IconDialHighOutline',
  'IconDialLowOutline',
  'IconDialMediumOutline',
  'IconDictionaryOutline',
  'IconDigitalTechtransformationOutline',
  'IconDiningOutline',
  'IconDisabilityInsuranceOutline',
  'IconDisplayPowerOutline',
  'IconDocOutline',
  'IconDocumentAlertOutline',
  'IconDocumentDownloadOutline',
  'IconDocumentExportOutline',
  'IconDocumentFileOutline',
  'IconDocumentLinkOutline',
  'IconDocumentMultipleOutline',
  'IconDocumentOutline',
  'IconDocumentPoliciesOutline',
  'IconDocumentSendOutline',
  'IconDocumentTextOutline',
  'IconDoorClosedOutline',
  'IconDoorOpenedOutline',
  'IconDownChevronCircleOutline',
  'IconDownChevronOutline',
  'IconDownloadCloudOutline',
  'IconDownloadLightOutline',
  'IconDownloadOutline',
  'IconDowntrendOutline',
  'IconDragHandleOutline',
  'IconDuplicateOutline',
  'IconEditOutline',
  'IconEducationOutline',
  'IconElevatorOutline',
  'IconEmailOutline',
  'IconEndProcessOutline',
  'IconEngagementOutline',
  'IconEnterLeftOutline',
  'IconEnterRightOutline',
  'IconErrorOutline',
  'IconExclamationOutline',
  'IconExitOutline',
  'IconExpandChevronOutline',
  'IconExpandOutline',
  'IconExtendOutline',
  'IconExtensionOutline',
  'IconFamilyOutline',
  'IconFemaleSymbolOutline',
  'IconFileOutline',
  'IconFilterOutline',
  'IconFilterRemoveOutline',
  'IconFireExitOutline',
  'IconFireExtinguisherOutline',
  'IconFireOutline',
  'IconFirehoseOutline',
  'IconFirstaidOutline',
  'IconFlagOutline',
  'IconFlagsOutline',
  'IconFlashDriveOutline',
  'IconFlowerOutline',
  'IconFnbOutline',
  'IconFolderAddOutline',
  'IconFolderClosedOutline',
  'IconFolderDeleteOutline',
  'IconFolderDownloadOutline',
  'IconFolderOpenAngledOutline',
  'IconFolderOpenedOutline',
  'IconFolderPlusOutline',
  'IconFoodbeverageOutline',
  'IconFooterOutline',
  'IconGameroomOutline',
  'IconGanttChartOutline',
  'IconGenderNeutralOutline',
  'IconGiftOutline',
  'IconGlobeMapOutline',
  'IconGlobeOutline',
  'IconGovernanceOutline',
  'IconGridViewOutline',
  'IconGroupOutline',
  'IconGrowRevenueOutline',
  'IconGrowthOutline',
  'IconHandOutline',
  'IconHandWaveOutline',
  'IconHashtagOutline',
  'IconHazardOutline',
  'IconHeaderOutline',
  'IconHelpQuestionOutline',
  'IconHoldingGlassOutline',
  'IconHomeFilterOutline',
  'IconHomeOutline',
  'IconHorizontalMoreOutline',
  'IconHospitalOutline',
  'IconHubOutline',
  'IconIdcardOutline',
  'IconImageOutline',
  'IconImmersiveTechnologyOutline',
  'IconInfinityOutline',
  'IconInformationLetterOutline',
  'IconInformationOutline',
  'IconJewelryOutline',
  'IconJunkOutline',
  'IconKanbanOutline',
  'IconKeyChangeOutline',
  'IconKeyboardOutline',
  'IconKpiOutline',
  'IconLabsOutline',
  'IconLayoutOutline',
  'IconLeaderOutline',
  'IconLeftChevronCircleOutline',
  'IconLeftChevronOutline',
  'IconLensApertureOutline',
  'IconLibraryOutline',
  'IconLibraryReportsOutline',
  'IconLifeInsuranceOutline',
  'IconLightbulbOutline',
  'IconLikeOutline',
  'IconLinkBrokenOutline',
  'IconLinkOutline',
  'IconLinkUnlinkedOutline',
  'IconListBarViewOutline',
  'IconListFormatOutline',
  'IconListPlayOutline',
  'IconListViewOutline',
  'IconLocationLockedOutline',
  'IconLocationOutline',
  'IconLockOffOutline',
  'IconLockclosedLockedOutline',
  'IconLockersOutline',
  'IconLockopenUnlockOutline',
  'IconLoginOutline',
  'IconLogoutOutline',
  'IconMailboxOutline',
  'IconMaleSymbolOutline',
  'IconManAndWomanOutline',
  'IconManOutline',
  'IconManageResourcesOutline',
  'IconManagementOutline',
  'IconManufacturerOutline',
  'IconMapLocationOutline',
  'IconMapOutline',
  'IconMarketingOutline',
  'IconMeetingOutline',
  'IconMeetingRoomOutline',
  'IconMentionsOutline',
  'IconMenuOutline',
  'IconMenuViewOutline',
  'IconMicrophoneOutline',
  'IconMinimizeOutline',
  'IconMinusOutline',
  'IconMoonOutline',
  'IconMortgageOutline',
  'IconMortgagePaymentOutline',
  'IconMoveOutline',
  'IconMuteOutline',
  'IconNeighborhoodOutline',
  'IconNetworkOutline',
  'IconNetworkPortOutline',
  'IconNewsOutline',
  'IconNewsReportOutline',
  'IconNoteOutline',
  'IconNotebookOutline',
  'IconNoteplusOutline',
  'IconNotificationOutline',
  'IconNotificationsAlertOutline',
  'IconNotificationsFirstOutline',
  'IconNotificationsOffOutline',
  'IconNotpublishedOutline',
  'IconObjectOutline',
  'IconOctagramOutline',
  'IconOfficeOutline',
  'IconOilpipelineOutline',
  'IconOilplatformOutline',
  'IconOiltankOutline',
  'IconOpenInNewOutline',
  'IconOpenInNewWindowOutline',
  'IconOrgChartOutline',
  'IconPalmTreeOutline',
  'IconPaperAirplaneOutline',
  'IconPaperOutline',
  'IconPaperclipOutline',
  'IconParksOutdoorsOutline',
  'IconParticulatesOutline',
  'IconPartnershipOutline',
  'IconPauseOutline',
  'IconPaymentOutline',
  'IconPdfOutline',
  'IconPenOutline',
  'IconPencilOutline',
  'IconPermittedWithCautionOutline',
  'IconPersonOutline',
  'IconPhysicianOutline',
  'IconPieChartOutline',
  'IconPinOutline',
  'IconPinboardOutline',
  'IconPlaceOutline',
  'IconPlaceholderOutline',
  'IconPlacingGlassOutline',
  'IconPlatformOutline',
  'IconPlayOutline',
  'IconPlusOutline',
  'IconPollOutline',
  'IconPowerBiReportOutline',
  'IconPowerButtonOutline',
  'IconPowerPlantOutline',
  'IconPowerbiOutline',
  'IconPowerportPlugOutletOutline',
  'IconPptOutline',
  'IconPraiseGratitudeOutline',
  'IconPrescriptionOutline',
  'IconPrinterOutline',
  'IconProductivityOutline',
  'IconProfitabilityOutline',
  'IconProjectorOutline',
  'IconPurposeOutline',
  'IconQrcodeOutline',
  'IconQueryOutline',
  'IconRadioOutline',
  'IconRatingOutline',
  'IconRealestateOutline',
  'IconRedisOutline',
  'IconRedoOutline',
  'IconRefreshOutline',
  'IconRejectOutline',
  'IconReturnOutline',
  'IconRevenueOutline',
  'IconRevertOutline',
  'IconRibbon1StPlaceOutline',
  'IconRibbon2NdPlaceOutline',
  'IconRibbon3RdPlaceOutline',
  'IconRightChevronCircleOutline',
  'IconRightChevronOutline',
  'IconSaveOutline',
  'IconSavemoneyOutline',
  'IconSavingsOutline',
  'IconScreenMirroringOutline',
  'IconSearchNotFoundOutline',
  'IconSearchOutline',
  'IconSectionsOutline',
  'IconSelectionOutline',
  'IconSerenitySpaceOutline',
  'IconServiceOutline',
  'IconSettingOutline',
  'IconShareOutline',
  'IconShieldCheckOutline',
  'IconShieldHalfOutline',
  'IconShieldOffOutline',
  'IconShieldOutline',
  'IconShipOutline',
  'IconShoppingBagOutline',
  'IconShoppingBasketOutline',
  'IconShoppingCartOutline',
  'IconShowerOutline',
  'IconShuttlebusOutline',
  'IconSideEyesOutline',
  'IconSignOffOutline',
  'IconSignpostOutline',
  'IconSiteLinkOutline',
  'IconSittingOutline',
  'IconSmartphoneOutline',
  'IconSortingAscendantOutline',
  'IconSortingDescendantOutline',
  'IconSortingOutline',
  'IconSparkLineOutline',
  'IconSpeakOutline',
  'IconSpeedometerOutline',
  'IconSpiderChartOutline',
  'IconSpinnerOutline',
  'IconStarOutline',
  'IconStewardshipOutline',
  'IconStickerOutline',
  'IconStrategyOutline',
  'IconSuccessIncompleteOutline',
  'IconSuccessOutline',
  'IconSummaryPrioritizationOutline',
  'IconSurveyCheckmarkOutline',
  'IconSurveyOutline',
  'IconSurveyScale1Outline',
  'IconSurveyScale2Outline',
  'IconSurveyScale3Outline',
  'IconSurveyScale4Outline',
  'IconSurveyScale5Outline',
  'IconTableDataCompressedOutline',
  'IconTableDataOutline',
  'IconTabletOutline',
  'IconTagOutline',
  'IconTalentOutline',
  'IconTankerOutline',
  'IconTargetOutline',
  'IconTelecomOutline',
  'IconTextBoxOutline',
  'IconTextOutline',
  'IconThermometerOutline',
  'IconThumbDownOutline',
  'IconThumbUpOutline',
  'IconTicketOutline',
  'IconTimeLapseOutline',
  'IconTimeOutline',
  'IconToggleOutline',
  'IconTouchscreenOutline',
  'IconTrainRailwayOutline',
  'IconTransformOutline',
  'IconTreeViewOutline',
  'IconTrophyOutline',
  'IconTruckConnectedOutline',
  'IconTruckOutline',
  'IconTypographyFontsOutline',
  'IconUmbrellaOutline',
  'IconUncertaintyOutline',
  'IconUnpinOutline',
  'IconUpChevronCircleOutline',
  'IconUpChevronOutline',
  'IconUpdateOutline',
  'IconUploadLightOutline',
  'IconUploadOutline',
  'IconUptrendOutline',
  'IconUserInactiveOutline',
  'IconVectorOutline',
  'IconVennAbHorizontalOutline',
  'IconVennAbVerticalOutline',
  'IconVennAbcOutline',
  'IconVennAbcReversedOutline',
  'IconVerticalMoreOutline',
  'IconVideoConferenceOutline',
  'IconVideoOutline',
  'IconViewOffOutline',
  'IconViewOutline',
  'IconVisitorOutline',
  'IconVolumeOffOutline',
  'IconVolumeOnOutline',
  'IconVolumeUpOutline',
  'IconWaitOutline',
  'IconWalkingWorkstationOutline',
  'IconWalletOutline',
  'IconWarningOutline',
  'IconWaterLeakOutline',
  'IconWaterdropOutline',
  'IconWealthOutline',
  'IconWebcastOutline',
  'IconWebcastStudioOutline',
  'IconWebsiteOutline',
  'IconWeightOutline',
  'IconWifiOutline',
  'IconWindmillOutline',
  'IconWomanOutline',
  'IconWorkflowOutline',
  'IconWorkoutOutline',
  'IconXbrlOutline',
  'IconXlsOutline',
  'IconZoomInOutline',
  'IconZoomOutOutline',
];

export const iconV2Options = [
  'IconV2AddDeleteOutline',
  'IconV2AgentOutline',
  'IconV2AiEditOutline',
  'IconV2AlertOutline',
  'IconV2AlumniOutline',
  'IconV2AnalysisOutline',
  'IconV2AnimationOutline',
  'IconV2ArchiveOutline',
  'IconV2ArrowLeftOutline',
  'IconV2ArrowRightOutline',
  'IconV2AttachmentOutline',
  'IconV2AvatarOutline',
  'IconV2BarChartOutline',
  'IconV2BathroomAllGenderOutline',
  'IconV2BathroomFamilyOutline',
  'IconV2BathroomFemaleOutline',
  'IconV2BathroomMaleOutline',
  'IconV2BellOutline',
  'IconV2BriefcaseOutline',
  'IconV2BuildingOutline',
  'IconV2CalendarOutline',
  'IconV2ClockOutline',
  'IconV2CloseOutline',
  'IconV2CloudOutline',
  'IconV2CoffeeOutline',
  'IconV2ColourSwatchOutline',
  'IconV2CommentOutline',
  'IconV2CommentsMessagesOutline',
  'IconV2CommunityOutline',
  'IconV2ComputerOutline',
  'IconV2CookieOutline',
  'IconV2CopyToClipboardOutline',
  'IconV2CorrectOutline',
  'IconV2CustomerServiceOutline',
  'IconV2DataAnalysisOutline',
  'IconV2DatabaseOutline',
  'IconV2DisabilityOutline',
  'IconV2DishwasherOutline',
  'IconV2DocumentDirectoryOutline',
  'IconV2DocumentDraftOutline',
  'IconV2DollarOutline',
  'IconV2DownloadOutline',
  'IconV2EditOutline',
  'IconV2ElevatorOutline',
  'IconV2EmailOutline',
  'IconV2ErrorOutline',
  'IconV2EventOutline',
  'IconV2ExportOutline',
  'IconV2EyeOutline',
  'IconV2FileOutline',
  'IconV2FilterOutline',
  'IconV2FolderDocumentsOutline',
  'IconV2FolderOutline',
  'IconV2FontsOutline',
  'IconV2FoodOutline',
  'IconV2FormOutline',
  'IconV2GlobeOutline',
  'IconV2GovernanceOutline',
  'IconV2GridViewOutline',
  'IconV2GroupOutline',
  'IconV2HeadphoneOutline',
  'IconV2HeartOutline',
  'IconV2HiddenOutline',
  'IconV2HomeOutline',
  'IconV2InboxMessagesOutline',
  'IconV2IncorrectOutline',
  'IconV2IndividualFocusRoomOutline',
  'IconV2InformationOutline',
  'IconV2LactationRoomOutline',
  'IconV2LightbulbOutline',
  'IconV2LikeOutline',
  'IconV2LinkOutline',
  'IconV2ListViewOutline',
  'IconV2LocationOutline',
  'IconV2LockOutline',
  'IconV2MarginsOutline',
  'IconV2MeetingRoomOutline',
  'IconV2MicrophoneOutline',
  'IconV2MobileOutline',
  'IconV2MothersRoomOutline',
  'IconV2MousePointerOutline',
  'IconV2PaddingOutline',
  'IconV2PauseOutline',
  'IconV2PenOutline',
  'IconV2PersonOutline',
  'IconV2PhoneboothOutline',
  'IconV2PieChartOutline',
  'IconV2PinOutline',
  'IconV2PlayOutline',
  'IconV2PrayerRoomOutline',
  'IconV2PrinterOutline',
  'IconV2PuzzleOutline',
  'IconV2QuestionOutline',
  'IconV2QuizOutline',
  'IconV2ResetOutline',
  'IconV2RobotOutline',
  'IconV2RotateClockwiseOutline',
  'IconV2SearchAiOutline',
  'IconV2SearchOutline',
  'IconV2SendOutline',
  'IconV2SettingsOutline',
  'IconV2ShoppingCartOutline',
  'IconV2ShowerOutline',
  'IconV2StairsOutline',
  'IconV2StarOutline',
  'IconV2SuccessOutline',
  'IconV2TaxRegulationsOutline',
  'IconV2ThoughtOutline',
  'IconV2TrashOutline',
  'IconV2UploadOutline',
  'IconV2VaultOutline',
  'IconV2VerifiedOutline',
  'IconV2VideoOutline',
  'IconV2VolumeOutline',
  'IconV2WidthOutline',
  'IconV2WifiOutline',
  'IconV2ZoomInOutline',
  'IconV2ZoomOutOutline',
]

/**
 * Categorized icon options for more organized selection
 */
export const categorizedIconOptions = {
  // Navigation icons
  navigation: [
    'IconArrowDecreaseOutline',
    'IconArrowDecreaseSmallOutline',
    'IconArrowDownBoldOutline',
    'IconArrowDownOutline',
    'IconArrowDownSmallOutline',
    'IconArrowIncreaseOutline',
    'IconArrowIncreaseSmallOutline',
    'IconArrowLeftOutline',
    'IconArrowLeftSmallOutline',
    'IconArrowRightOutline',
    'IconArrowRightSmallOutline',
    'IconArrowUpBoldOutline',
    'IconArrowUpOutline',
    'IconArrowUpSmallOutline',
    'IconChevronDoubleDownOutline',
    'IconChevronDoubleLeftOutline',
    'IconChevronDoubleRightOutline',
    'IconCollapseChevronOutline',
    'IconDownChevronCircleOutline',
    'IconDownChevronOutline',
    'IconExpandChevronOutline',
    'IconLeftChevronCircleOutline',
    'IconLeftChevronOutline',
    'IconMenuOutline',
    'IconMenuViewOutline',
    'IconRightChevronCircleOutline',
    'IconRightChevronOutline',
    'IconUpChevronCircleOutline',
    'IconUpChevronOutline',
  ],
  
  // Action icons
  actions: [
    'IconAccountRemoveOutline',
    'IconAddUserOutline',
    'IconCircleDeleteOutline',
    'IconCircleSaveOutline',
    'IconCloudDeleteOutline',
    'IconDataAddprefixOutline',
    'IconDataAddsuffixOutline',
    'IconDeleteOutline',
    'IconDocumentDownloadOutline',
    'IconDownloadCloudOutline',
    'IconDownloadLightOutline',
    'IconDownloadOutline',
    'IconEditOutline',
    'IconFilterRemoveOutline',
    'IconFolderAddOutline',
    'IconFolderDeleteOutline',
    'IconFolderDownloadOutline',
    'IconSaveOutline',
    'IconSavemoneyOutline',
    'IconUploadLightOutline',
    'IconUploadOutline',
  ],
  
  // Status icons
  status: [
    'IconAccountAlertOutline',
    'IconAccountCheckOutline',
    'IconAlertOutline',
    'IconCheckHookOutline',
    'IconCheckMarkOutline',
    'IconCheckboxOutline',
    'IconCircleCheckmarkOutline',
    'IconCircleWarningOutline',
    'IconCloudAlertOutline',
    'IconCloudCheckOutline',
    'IconDocumentAlertOutline',
    'IconErrorOutline',
    'IconInformationLetterOutline',
    'IconInformationOutline',
    'IconNotificationsAlertOutline',
    'IconShieldCheckOutline',
    'IconSuccessIncompleteOutline',
    'IconSuccessOutline',
    'IconSurveyCheckmarkOutline',
    'IconWarningOutline',
  ],
  
  // Common UI icons
  ui: [
    'IconAddUserOutline',
    'IconCalendarAcceptedOutline',
    'IconCalendarClockOutline',
    'IconCalendarDeclinedOutline',
    'IconCalendarOutline',
    'IconDatabaseSearchOutline',
    'IconHomeFilterOutline',
    'IconHomeOutline',
    'IconNotificationOutline',
    'IconNotificationsAlertOutline',
    'IconNotificationsFirstOutline',
    'IconNotificationsOffOutline',
    'IconSearchNotFoundOutline',
    'IconSearchOutline',
    'IconUserInactiveOutline',
  ],
  
  // All other icons
  other: [
    'Icon3By3GridOutline',
    'Icon3DimensionsOutline',
    'Icon4LframeworkOutline',
    'IconAcceptOutline',
    'IconAccessibilityOutline',
    'IconAccessibleOutline',
    'IconAccountBoxOutline',
    'IconAccountConvertOutline',
    'IconAccountSwitchOutline',
    'IconAggregateOutline',
    'IconAirFilterOutline',
    'IconAirplaneOutline',
    'IconAnalysisOutline',
    'IconApparelOutline',
    'IconArchiveAltOutline',
    'IconArchiveOutline',
    'IconArtThemesOutline',
    'IconAskQuestionOutline',
    'IconAtmOutline',
    'IconAudienceOutline',
    'IconAutomobileOutline',
    'IconAvatarOutline',
    'IconAwardRibbonOutline',
    'IconBarChartOutline',
    'IconBargraphOutline',
    'IconBatteryHighOutline',
    'IconBatteryLowOutline',
    'IconBatteryMediumOutline',
    'IconBeakerOutline',
    'IconBiometricsOutline',
    'IconBoatOutline',
    'IconBookOutline',
    'IconBotOutline',
    'IconBoxOpenOutline',
    'IconBoxOutline',
    'IconBridgeChartOutline',
    'IconBrightnessOutline',
    'IconBubblePlotOutline',
    'IconBudgetOutline',
    'IconBuildingOutline',
    'IconBusPublicTransportationOutline',
    'IconBusinessServicesPrinterOutline',
    'IconButtonOutline',
    'IconCalculatorOutline',
    'IconCallOutline',
    'IconCameraMicSpeakersOutline',
    'IconCameraOutline',
    'IconCapitalOutline',
    'IconCarersSpaceOutline',
    'IconCenterMapOutline',
    'IconChangeOutline',
    'IconCircleEmptyOutline',
    'IconCircleMinusOutline',
    'IconCircleMoreOutline',
    'IconCirclePercentOutline',
    'IconCirclePlusOutline',
    'IconCircleRadioOutline',
    'IconCircleStarOutline',
    'IconCircuitBoardBoxOutline',
    'IconClappingApplauseOutline',
    'IconClinicOutline',
    'IconCloseOutline',
    'IconCloudClockOutline',
    'IconCloudDisableOutline',
    'IconCloudLoadingOutline',
    'IconCloudOutline',
    'IconCogsOutline',
    'IconCommentOutline',
    'IconCommentaryOutline',
    'IconCommunityOutline',
    'IconCompassOutline',
    'IconConfettiCelebrationOutline',
    'IconConfigurationOutline',
    'IconConfirmedOutline',
    'IconContactsOutline',
    'IconContainerOutline',
    'IconConvertOutline',
    'IconCookieOutline',
    'IconCopyOutline',
    'IconCostDollarOutline',
    'IconCreditCardOutline',
    'IconCreditCardPaymentOutline',
    'IconCurrencyExchangeOutline',
    'IconDashboardOutline',
    'IconDataLettersOutline',
    'IconDataLowercaseOutline',
    'IconDataMixedOutline',
    'IconDataNumericOutline',
    'IconDataOutline',
    'IconDataTrimOutline',
    'IconDataUppercaseOutline',
    'IconDataValueOutline',
    'IconDatabaseOutline',
    'IconDebtFreeOutline',
    'IconDeskChairOutline',
    'IconDesktopOutline',
    'IconDialHighOutline',
    'IconDialLowOutline',
    'IconDialMediumOutline',
    'IconDictionaryOutline',
    'IconDigitalTechtransformationOutline',
    'IconDiningOutline',
    'IconDisabilityInsuranceOutline',
    'IconDisplayPowerOutline',
    'IconDocOutline',
    'IconDocumentExportOutline',
    'IconDocumentFileOutline',
    'IconDocumentLinkOutline',
    'IconDocumentMultipleOutline',
    'IconDocumentOutline',
    'IconDocumentPoliciesOutline',
    'IconDocumentSendOutline',
    'IconDocumentTextOutline',
    'IconDoorClosedOutline',
    'IconDoorOpenedOutline',
    'IconDowntrendOutline',
    'IconDragHandleOutline',
    'IconDuplicateOutline',
    'IconEducationOutline',
    'IconElevatorOutline',
    'IconEmailOutline',
    'IconEndProcessOutline',
    'IconEngagementOutline',
    'IconEnterLeftOutline',
    'IconEnterRightOutline',
    'IconExclamationOutline',
    'IconExitOutline',
    'IconExpandOutline',
    'IconExtendOutline',
    'IconExtensionOutline',
    'IconFamilyOutline',
    'IconFemaleSymbolOutline',
    'IconFileOutline',
    'IconFilterOutline',
    'IconFireExitOutline',
    'IconFireExtinguisherOutline',
    'IconFireOutline',
    'IconFirehoseOutline',
    'IconFirstaidOutline',
    'IconFlagOutline',
    'IconFlagsOutline',
    'IconFlashDriveOutline',
    'IconFlowerOutline',
    'IconFnbOutline',
    'IconFolderClosedOutline',
    'IconFolderOpenAngledOutline',
    'IconFolderOpenedOutline',
    'IconFolderPlusOutline',
    'IconFoodbeverageOutline',
    'IconFooterOutline',
    'IconGameroomOutline',
    'IconGanttChartOutline',
    'IconGenderNeutralOutline',
    'IconGiftOutline',
    'IconGlobeMapOutline',
    'IconGlobeOutline',
    'IconGovernanceOutline',
    'IconGridViewOutline',
    'IconGroupOutline',
    'IconGrowRevenueOutline',
    'IconGrowthOutline',
    'IconHandOutline',
    'IconHandWaveOutline',
    'IconHashtagOutline',
    'IconHazardOutline',
    'IconHeaderOutline',
    'IconHelpQuestionOutline',
    'IconHoldingGlassOutline',
    'IconHorizontalMoreOutline',
    'IconHospitalOutline',
    'IconHubOutline',
    'IconIdcardOutline',
    'IconImageOutline',
    'IconImmersiveTechnologyOutline',
    'IconInfinityOutline',
    'IconJewelryOutline',
    'IconJunkOutline',
    'IconKanbanOutline',
    'IconKeyChangeOutline',
    'IconKeyboardOutline',
    'IconKpiOutline',
    'IconLabsOutline',
    'IconLayoutOutline',
    'IconLeaderOutline',
    'IconLensApertureOutline',
    'IconLibraryOutline',
    'IconLibraryReportsOutline',
    'IconLifeInsuranceOutline',
    'IconLightbulbOutline',
    'IconLikeOutline',
    'IconLinkBrokenOutline',
    'IconLinkOutline',
    'IconLinkUnlinkedOutline',
    'IconListBarViewOutline',
    'IconListFormatOutline',
    'IconListPlayOutline',
    'IconListViewOutline',
    'IconLocationLockedOutline',
    'IconLocationOutline',
    'IconLockOffOutline',
    'IconLockclosedLockedOutline',
    'IconLockersOutline',
    'IconLockopenUnlockOutline',
    'IconLoginOutline',
    'IconLogoutOutline',
    'IconMailboxOutline',
    'IconMaleSymbolOutline',
    'IconManAndWomanOutline',
    'IconManOutline',
    'IconManageResourcesOutline',
    'IconManagementOutline',
    'IconManufacturerOutline',
    'IconMapLocationOutline',
    'IconMapOutline',
    'IconMarketingOutline',
    'IconMeetingOutline',
    'IconMeetingRoomOutline',
    'IconMentionsOutline',
    'IconMicrophoneOutline',
    'IconMinimizeOutline',
    'IconMinusOutline',
    'IconMoonOutline',
    'IconMortgageOutline',
    'IconMortgagePaymentOutline',
    'IconMoveOutline',
    'IconMuteOutline',
    'IconNeighborhoodOutline',
    'IconNetworkOutline',
    'IconNetworkPortOutline',
    'IconNewsOutline',
    'IconNewsReportOutline',
    'IconNoteOutline',
    'IconNotebookOutline',
    'IconNoteplusOutline',
    'IconNotpublishedOutline',
    'IconObjectOutline',
    'IconOctagramOutline',
    'IconOfficeOutline',
    'IconOilpipelineOutline',
    'IconOilplatformOutline',
    'IconOiltankOutline',
    'IconOpenInNewOutline',
    'IconOpenInNewWindowOutline',
    'IconOrgChartOutline',
    'IconPalmTreeOutline',
    'IconPaperAirplaneOutline',
    'IconPaperOutline',
    'IconPaperclipOutline',
    'IconParksOutdoorsOutline',
    'IconParticulatesOutline',
    'IconPartnershipOutline',
    'IconPauseOutline',
    'IconPaymentOutline',
    'IconPdfOutline',
    'IconPenOutline',
    'IconPencilOutline',
    'IconPermittedWithCautionOutline',
    'IconPersonOutline',
    'IconPhysicianOutline',
    'IconPieChartOutline',
    'IconPinOutline',
    'IconPinboardOutline',
    'IconPlaceOutline',
    'IconPlaceholderOutline',
    'IconPlacingGlassOutline',
    'IconPlatformOutline',
    'IconPlayOutline',
    'IconPlusOutline',
    'IconPollOutline',
    'IconPowerBiReportOutline',
    'IconPowerButtonOutline',
    'IconPowerPlantOutline',
    'IconPowerbiOutline',
    'IconPowerportPlugOutletOutline',
    'IconPptOutline',
    'IconPraiseGratitudeOutline',
    'IconPrescriptionOutline',
    'IconPrinterOutline',
    'IconProductivityOutline',
    'IconProfitabilityOutline',
    'IconProjectorOutline',
    'IconPurposeOutline',
    'IconQrcodeOutline',
    'IconQueryOutline',
    'IconRadioOutline',
    'IconRatingOutline',
    'IconRealestateOutline',
    'IconRedisOutline',
    'IconRedoOutline',
    'IconRefreshOutline',
    'IconRejectOutline',
    'IconReturnOutline',
    'IconRevenueOutline',
    'IconRevertOutline',
    'IconRibbon1StPlaceOutline',
    'IconRibbon2NdPlaceOutline',
    'IconRibbon3RdPlaceOutline',
    'IconSavingsOutline',
    'IconScreenMirroringOutline',
    'IconSectionsOutline',
    'IconSelectionOutline',
    'IconSerenitySpaceOutline',
    'IconServiceOutline',
    'IconSettingOutline',
    'IconShareOutline',
    'IconShieldHalfOutline',
    'IconShieldOffOutline',
    'IconShieldOutline',
    'IconShipOutline',
    'IconShoppingBagOutline',
    'IconShoppingBasketOutline',
    'IconShoppingCartOutline',
    'IconShowerOutline',
    'IconShuttlebusOutline',
    'IconSideEyesOutline',
    'IconSignOffOutline',
    'IconSignpostOutline',
    'IconSiteLinkOutline',
    'IconSittingOutline',
    'IconSmartphoneOutline',
    'IconSortingAscendantOutline',
    'IconSortingDescendantOutline',
    'IconSortingOutline',
    'IconSparkLineOutline',
    'IconSpeakOutline',
    'IconSpeedometerOutline',
    'IconSpiderChartOutline',
    'IconSpinnerOutline',
    'IconStarOutline',
    'IconStewardshipOutline',
    'IconStickerOutline',
    'IconStrategyOutline',
    'IconSummaryPrioritizationOutline',
    'IconSurveyOutline',
    'IconSurveyScale1Outline',
    'IconSurveyScale2Outline',
    'IconSurveyScale3Outline',
    'IconSurveyScale4Outline',
    'IconSurveyScale5Outline',
    'IconTableDataCompressedOutline',
    'IconTableDataOutline',
    'IconTabletOutline',
    'IconTagOutline',
    'IconTalentOutline',
    'IconTankerOutline',
    'IconTargetOutline',
    'IconTelecomOutline',
    'IconTextBoxOutline',
    'IconTextOutline',
    'IconThermometerOutline',
    'IconThumbDownOutline',
    'IconThumbUpOutline',
    'IconTicketOutline',
    'IconTimeLapseOutline',
    'IconTimeOutline',
    'IconToggleOutline',
    'IconTouchscreenOutline',
    'IconTrainRailwayOutline',
    'IconTransformOutline',
    'IconTreeViewOutline',
    'IconTrophyOutline',
    'IconTruckConnectedOutline',
    'IconTruckOutline',
    'IconTypographyFontsOutline',
    'IconUmbrellaOutline',
    'IconUncertaintyOutline',
    'IconUnpinOutline',
    'IconUpdateOutline',
    'IconUptrendOutline',
    'IconVectorOutline',
    'IconVennAbHorizontalOutline',
    'IconVennAbVerticalOutline',
    'IconVennAbcOutline',
    'IconVennAbcReversedOutline',
    'IconVerticalMoreOutline',
    'IconVideoConferenceOutline',
    'IconVideoOutline',
    'IconViewOffOutline',
    'IconViewOutline',
    'IconVisitorOutline',
    'IconVolumeOffOutline',
    'IconVolumeOnOutline',
    'IconVolumeUpOutline',
    'IconWaitOutline',
    'IconWalkingWorkstationOutline',
    'IconWalletOutline',
    'IconWaterLeakOutline',
    'IconWaterdropOutline',
    'IconWealthOutline',
    'IconWebcastOutline',
    'IconWebcastStudioOutline',
    'IconWebsiteOutline',
    'IconWeightOutline',
    'IconWifiOutline',
    'IconWindmillOutline',
    'IconWomanOutline',
    'IconWorkflowOutline',
    'IconWorkoutOutline',
    'IconXbrlOutline',
    'IconXlsOutline',
    'IconZoomInOutline',
    'IconZoomOutOutline',
  ]
};

/**
 * Helper function to get a display name for an icon
 * Converts 'IconHomeOutline' to 'Home'
 */
export function getIconDisplayName(iconName: IconName): string {
  return iconName
    .replace(/^Icon/, '') // Remove 'Icon' prefix
    .replace(/Outline$/, '') // Remove 'Outline' suffix
    .replace(/([A-Z])/g, ' $1') // Add spaces between words
    .trim(); // Remove extra spaces
}
